const SearchIconPc = ({ width = 20, height = 20, color = '#000000' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.3">
        <path
          d="M18.5349 18.4641C18.6124 18.3867 18.6738 18.2949 18.7157 18.1937C18.7576 18.0926 18.7791 17.9842 18.7791 17.8748C18.7791 17.7653 18.7576 17.6569 18.7157 17.5558C18.6738 17.4547 18.6124 17.3628 18.5349 17.2854L15.5891 14.3395C15.4328 14.1832 15.2209 14.0953 14.9998 14.0952C14.7788 14.0951 14.5667 14.1829 14.4104 14.3391C14.254 14.4954 14.1661 14.7074 14.166 14.9284C14.1659 15.1495 14.2537 15.3615 14.4099 15.5179L17.3566 18.4637C17.5129 18.6199 17.7248 18.7077 17.9458 18.7077C18.1667 18.7077 18.3787 18.6199 18.5349 18.4637V18.4641Z"
          fill={color}
        />
        <path
          d="M10 15.8333C6.77833 15.8333 4.16667 13.2217 4.16667 10C4.16667 6.77833 6.77833 4.16667 10 4.16667C13.2217 4.16667 15.8333 6.77833 15.8333 10C15.8333 13.2217 13.2217 15.8333 10 15.8333ZM10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85792 14.1421 2.5 10 2.5C5.85792 2.5 2.5 5.85792 2.5 10C2.5 14.1421 5.85792 17.5 10 17.5Z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default SearchIconPc
